import { Store } from '@core/types'
import { Observable, Subject } from 'rxjs'

const storage = window.localStorage

/**
 * TODO maybe we should put this in to the  core lib?
 */
export class StringStorage implements Store<string | null> {
    private _value: string | null
    private sub = new Subject<string | null>()

    constructor(private key: string) {
        this._value = null
    }

    clear = () => this.change(null)

    change = (val: string | null) => {
        if (val == null) {
            storage.removeItem(this.key)
        } else storage.setItem(this.key, val)

        this._value = val
        this.sub.next(this._value)
    }

    load = () => {
        this._value = storage.getItem(this.key)
        this.sub.next(this._value)
    }

    changes = (): Observable<string | null> => {
        return this.sub
    }

    value = (): string | null => {
        return this._value
    }
}
